<!-- #3 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 pb-0"
        style="color: #23468c; font-weight: 500"
      >
        List of PAS
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="Pas"
      :loading="loader"
      class="elevation-1 custom-icon-size"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.active`]="{ item }">
        <span
          :class="
            item.active == 1
              ? 'badge'
              : item.active == 3
              ? 'badge-force'
              : 'badge-active'
          "
        >
          {{
            item.active == 1
              ? "In Progress"
              : item.active == 3
              ? "Force Closed"
              : "Completed"
          }}
        </span>
      </template>
      <template v-slot:[`item.driver_name`]="{ item }"
        >{{ item.driver_name }} ({{ item.driver_number }})
      </template>
      <template v-slot:[`item.purpose`]="{ item }">
        <span v-if="item.purpose == 'Both'"> Inbound & Outbound</span
        ><span v-else>{{ item.purpose }} </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_pas:pas_gate_token_timeline')"
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2" v-on="on" @click="timeline(item)">
              mdi-clipboard-text-clock-outline
            </v-icon>
          </template>
          <span> Timeline </span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="checkPermission('app_pas:pas_gate_token_timeline')"
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2" v-on="on" @click="findSummary(item)">
              mdi-archive-check-outline
            </v-icon>
          </template>
          <span> Token Summary </span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_pas:pas_gate_token_timeline') &&
            item.is_signature_done == 1
          "
        >
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              v-on="on"
              @click="downloadpdf(item.driver_declaration)"
            >
              mdi-file-account-outline
            </v-icon>
          </template>
          <span> Driver Decleration </span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="checkPermission('app_pas:pas_force_closed') && item.active == 1"
        >
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              v-on="on"
              @click="(forcePushed = true), (forceitem = item)"
            >
              mdi-lock-alert
            </v-icon>
          </template>
          <span> Forcefully Closed </span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.reported_in_datetime`]="{ item }">
        {{
          item.reported_in_datetime
            | localMomentNew
            | moment("DD MMM, YYYY hh:mm A")
        }}
      </template>

      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Token Number"
                  v-model="token_number"
                  outlined
                  clearable
                  @click:clear="clearInput('this.token_number')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="purposes"
                  outlined
                  v-model="purpose"
                  dense
                  chips
                  small-chips
                  label="Purpose"
                  @click:clear="clearInput('this.purpose')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="eventStatus"
                  outlined
                  v-model="latest_event_status"
                  dense
                  chips
                  small-chips
                  label="Event status"
                  @click:clear="clearInput('this.latest_event_status')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="storers"
                  outlined
                  v-model="storer_id"
                  dense
                  chips
                  small-chips
                  label="Storer"
                  item-text="storer_name"
                  item-value="id"
                  @click:clear="clearInput('this.storer_id')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="statuses"
                  outlined
                  v-model="active"
                  dense
                  chips
                  small-chips
                  label="Status"
                  @click:clear="clearInput('this.active')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="warehousees"
                  outlined
                  v-model="wms_warehouse_code"
                  dense
                  chips
                  small-chips
                  label="Warehouse"
                  @click:clear="clearInput('this.wms_warehouse_code')"
                  @input="checkFunction(wms_warehouse_code)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" sm="3" v-if="dock_numbers.length">
                <v-autocomplete
                  label="Dock Number Allocated"
                  hide-details="auto"
                  :items="dock_numbers"
                  multiple
                  outlined
                  v-model="dock_number"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="vehicles"
                  outlined
                  v-model="vehicle_type"
                  dense
                  chips
                  small-chips
                  label="Type of vehicle"
                  @click:clear="clearInput('this.vehicle_type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="9" :sm="dock_numbers.length ? 6 : 9" class="pl-0">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class="mr-2"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-2"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>
    </v-data-table>
    <template>
      <v-row justify="center">
        <v-dialog v-model="summary" persistent width="700">
          <v-card class="pl-0">
            <v-card-title class="card-title"
              >Token Summary-{{ tokenSummaryData.token_number }} ( Reported In :
              {{
                tokenSummaryData.reported_in_datetime
                  | localMomentNew
                  | moment("DD MMM, YYYY hh:mm A")
              }}
              )
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mb-0 pb-0">
              <v-row class="pl-0">
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div>
                      <b>Warehouse </b>
                    </div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0 text-medium-emphasis">
                        Warehouse Name
                      </div>
                      <div class="text-left col-md-7 p-0">
                        {{ tokenSummaryData.wms_warehouse_code }}
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex p-0 m-0"
                      v-if="tokenSummaryData.dock_number"
                    >
                      <div class="col-md-5 p-0">Dock Number Allocated</div>
                      <div class="text-left col-md-7 p-0">
                        {{ tokenSummaryData.dock_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Purpose</div>
                      <div class="text-left col-md-7 p-0">
                        <span v-if="tokenSummaryData.purpose == 'Both'">
                          Inbound & Outbound</span
                        ><span v-else>{{ tokenSummaryData.purpose }} </span>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Status</div>
                      <div class="text-left col-md-7 p-0">
                        <span
                          v-if="
                            tokenSummaryData.latest_event_status ==
                            'FORCE_CLOSED'
                          "
                          ><b>
                            {{ tokenSummaryData.latest_event_status }} ({{
                              tokenSummaryData.force_closed_comments
                            }})</b
                          ></span
                        >
                        <span v-else>{{
                          tokenSummaryData.latest_event_status
                        }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Security Details</b></div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">Gaurd</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.security_guard_name }}<br />
                        ({{ tokenSummaryData.security_guard_phone }})
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pl-0">
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Driver Details</b></div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        Driver Name
                      </div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.driver_name }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Driver Phone Number</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.driver_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Driver License Number</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.driver_license_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Additional with driver</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.additional_name }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">HSEEQ completed?</div>
                      <div class="text-left col-md-1 p-0">
                        {{
                          tokenSummaryData.is_signature_done == 0 ? "No" : "Yes"
                        }}
                      </div>
                      <v-tooltip
                        bottom
                        v-if="
                          checkPermission('app_pas:pas_gate_token_timeline') &&
                          tokenSummaryData.is_signature_done == 1
                        "
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            medium
                            class="mr-2"
                            v-on="on"
                            @click="
                              downloadpdf(tokenSummaryData.driver_declaration)
                            "
                          >
                            mdi-file-account-outline
                          </v-icon>
                        </template>
                        <span> Driver Decleration </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div>
                      <b>Vehicle Details </b>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Type of vehicle</div>
                      <div class="text-left col-md-7 p-0">
                        {{ tokenSummaryData.vehicle_type }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0 text-medium-emphasis">
                        Vehicle Number
                      </div>
                      <div class="text-left col-md-7 p-0">
                        {{ tokenSummaryData.vehicle_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-5 p-0">Vehicle Temprature</div>
                      <div class="text-left col-md-7 pl-1 pt-0">
                        {{ tokenSummaryData.vehicle_temperature }}°C
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="pl-0">
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Other Details</b></div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Supplier Name</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.supplier_name }}
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex p-0 m-0"
                      v-if="tokenSummaryData.invoice_number"
                    >
                      <div class="col-md-6 p-0">Invoice Number</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.invoice_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Invoice Quantity</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.invoice_quantity }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Reason for no invoice</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.reason_no_invoice_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Container Number</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.container_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Seal Number</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.seal_number }}
                      </div>
                    </div>
                    <!-- 
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Purpose</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.purpose }}
                      </div>
                    </div> -->
                  </v-col>

                  <v-col cols="12" class="pl-0">
                    <div><b>Driver Feedback</b></div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Overall Rating</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.delivery_experience_rating }}
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex p-0 m-0"
                      v-if="tokenSummaryData.rsa_staff_experience_rating"
                    >
                      <div class="col-md-6 p-0">Staff Rating</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.rsa_staff_experience_rating }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Reason for score</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.reason_for_score }}
                      </div>
                    </div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Comments</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.comments }}
                      </div>
                    </div>
                  </v-col>
                </v-col>

                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Dock Details</b></div>
                    <div
                      class="col-md-12 d-flex p-0 m-0"
                      v-if="tokenSummaryData.storer"
                    >
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        Storer Name
                      </div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.storer }}
                      </div>
                    </div>
                    <div
                      class="col-md-12 d-flex p-0 m-0"
                      v-if="tokenSummaryData.unloading_type"
                    >
                      <div class="col-md-6 p-0">Unloading type</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.unloading_type }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Dock In Comments</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.dock_in_remark }}
                      </div>
                    </div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">ASN / Shipment Number</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.asn_shipment_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">LPO/Reference Number</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.lpo_number }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Projected Quantity</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.projected_quantity }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Received/Loaded Quantity</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.received_quantity }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        Pallet Quantity:
                      </div>
                      <div class="text-left col-md-6 p-0">
                        <b> {{ tokenSummaryData.pallet_quantity }}</b>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        RTO Employee Count:
                      </div>
                      <div class="text-left col-md-6 p-0">
                        <b> {{ tokenSummaryData.rto_employee_count }}</b>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        TC Employee Count:
                      </div>
                      <div class="text-left col-md-6 p-0">
                        <b> {{ tokenSummaryData.tc_employee_count }}</b>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        WHA Employee Count:
                      </div>
                      <div class="text-left col-md-6 p-0">
                        <b> {{ tokenSummaryData.wha_employee_count }}</b>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        FLO Employee Count:
                      </div>
                      <div class="text-left col-md-6 p-0">
                        <b> {{ tokenSummaryData.flo_employee_count }}</b>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0 text-medium-emphasis">
                        Outsourced Employee Count:
                      </div>
                      <div class="text-left col-md-6 p-0">
                        <b> {{ tokenSummaryData.osl_employee_count }}</b>
                      </div>
                    </div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-6 p-0">Dock Out Comments</div>
                      <div class="text-left col-md-6 p-0">
                        {{ tokenSummaryData.dock_out_comment }}
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="d-flex justify-end">
              <v-btn color="white" variant="text" @click="summary = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <template>
      <v-row justify="center">
        <v-dialog v-model="timelinePopup" scrollable width="500">
          <v-card>
            <v-card-title style="display: inline"
              >Timeline Summary - {{ this.ShowToken }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px">
              <template>
                <div
                  class="history-tl-container-order pl-6"
                  v-for="data in trackingDetails"
                  :key="data"
                >
                  <ul class="tl p-0 mb-0">
                    <li class="tl-item" ng-repeat="item in history">
                      <!-- <v-icon class="icon-inside"
                          >mdi-truck-delivery-outline</v-icon
                        > -->
                      <div class="vertical-line">
                        <v-icon class="icon">mdi-truck-delivery-outline</v-icon>
                      </div>

                      <div cols="12" md="12">
                        <div class="timestamp">
                          {{
                            data.event_datetime
                              | localMomentNew
                              | moment("DD MMM, YYYY hh:mm A")
                          }}
                          <br />
                        </div>

                        <br />
                        <div class="timestamp mt-4">
                          {{ data.timezone }}
                        </div>
                        <br />

                        <div class="timestamp mt-8 mb-4">
                          {{ data.pas_user }} ({{ data.pas_user_role }})
                        </div>
                      </div>
                      <div cols="12" md="12">
                        <div class="item-detail">
                          {{ data.pas_event_code }}
                        </div>
                        <br />
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="d-flex justify-end">
              <v-btn
                color="white"
                variant="text"
                @click="(timelinePopup = false), (this.ShowToken = '')"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-dialog
      v-model="forcePushed"
      max-width="550px"
      close-delay="ma-5"
      @keydown.esc="forcePushed = false"
    >
      <v-card>
        <v-card-title class="card-title"
          >Force Close- {{ forceitem.token_number }} |
          {{ forceitem.driver_name }}({{ forceitem.driver_number }}) ,
          <span v-if="forceitem.purpose == 'Both'"> Inbound & Outbound</span
          ><span v-else>{{ forceitem.purpose }} </span>,
          {{
            forceitem.delivery_date | localMomentNew | moment("DD MMM, YYYY ")
          }}
          <v-spacer></v-spacer>
        </v-card-title>

        <v-divider></v-divider>
        <v-form ref="form">
          <v-card-text>
            <v-col>
              <v-text-field
                label="Comment"
                v-model="rowcomment"
                class="mt-0 pt-0 required"
                :rules="[(v) => !!v || 'Comment is required']"
              >
              </v-text-field>
            </v-col>
            <v-card-action>
              <v-btn
                small
                color="primary"
                class="ml-2"
                @click="forcePushedFunction"
                >Update
              </v-btn>
              <v-btn
                small
                color="error"
                class="ml-4"
                @click="(rowcomment = null), (forcePushed = false)"
                >Cancel</v-btn
              >
            </v-card-action>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data: () => ({
    dock_numbers: [],
    dock_number: [],

    forcePushed: false,
    loader: false,
    ShowToken: "",
    options: {},
    timelinePopup: false,
    trackingDetails: [],
    token_number: null,
    purpose: null,
    storer_id: null,
    active: null,
    storers: [],
    latest_event_status: null,
    from_date: null,
    to_date: null,
    dateMenuTo: false,
    dateMenu: false,
    summary: false,
    vehicle_type: null,
    purposes: [
      {
        text: "Inbound",
        value: 1,
      },
      {
        text: "Outbound",
        value: 2,
      },
      {
        text: "Both",
        value: 3,
      },
    ],
    eventStatus: [
      {
        text: "Vehicle Report In",
        value: "VEHICLE_REPORT_IN",
      },
      {
        text: "Driver Declaration",
        value: "DRIVER_DECLARATION",
      },
      {
        text: "Security - Gate In",
        value: "SECURITY_GATE_IN",
      },
      {
        text: "Warehouse - Doc In",
        value: "WAREHOUSE_DOCK_IN",
      },
      {
        text: "Warehouse - Doc Out",
        value: "WAREHOUSE_DOCK_OUT",
      },
      {
        text: "Security - Gate Out",
        value: "SECURITY_GATE_OUT",
      },
      {
        text: "Force - Closed",
        value: "FORCE_CLOSED",
      },
    ],

    tokenSummaryData: {
      payment_summary: {},
      order_details: {},
      shipping_address: {},
      billing_address: {},
    },
    headers: [
      {
        text: "Token Number",
        value: "token_number",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Driver Info",
        value: "driver_name",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },

      {
        text: "Driver License Number",
        value: "driver_license_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Event status",
        value: "latest_event_status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Purpose",
        value: "purpose",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Warehouse",
        value: "wms_warehouse_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Dock Number Allocated",
        value: "dock_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Vehicle Number",
        value: "vehicle_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Vehicle Type",
        value: "vehicle_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Supplier Name",
        value: "supplier_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Storer",
        value: "storer",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "active",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Reported Time",
        value: "reported_in_datetime",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
    ],
    Pas: [],
    warehousees: [],
    statuses: [
      {
        text: "In Progress",
        value: 1,
      },
      {
        text: "Completed",
        value: 2,
      },
      {
        text: "Force Closed",
        value: 3,
      },
    ],
    wms_warehouse_code: null,
    total: 0,
    vehicles: [],
    forceitem: {},
    warehouseesList: [],
  }),

  created() {
    this.fetchStore();
    if (this.$store.getters.user.user_category == 4) {
      this.active = 1;
      this.allFilters();
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchPas();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getPasUserList",
      "snackBar",
      "pasTimeline",
      "fetchStorelist",
      "downloadPasData",
      "downloadPasTemplate",
      "forceCLoseApi",
    ]),
    forcePushedFunction() {
      if (!this.$refs.form.validate()) return;

      if (this.rowcomment) {
        let payload = {
          id: this.forceitem.id,
          comments: this.rowcomment,
        };
        this.forceCLoseApi(payload)
          .then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.forcePushed = false;
            this.fetchPas();
          })
          .catch(() => {
            this.forcePushed = false;
          });
      }
    },
    fetchStore() {
      this.fetchStorelist().then((res) => {
        this.storers = res.data.storer;
        this.warehousees = res.data.warehouses.map(
          (obj) => Object.keys(obj)[0]
        );
        this.vehicles = res.data.vehicle_types;
        this.warehouseesList = res.data.warehouses;
      });
    },
    timeline(item) {
      this.ShowToken = item.token_number;
      this.pasTimeline(item.id).then((res) => {
        this.timelinePopup = true;
        this.trackingDetails = res.data;
      });
    },

    downloadpdf(path) {
      this.downloader = true;
      const parts = path.split("/");
      // The file name is the last part of the URL
      const fileName = parts[parts.length - 1];
      let url = `api/file_download?file_path=app_pas/upload_driver_declaration/${fileName}`;

      this.downloadPasTemplate(url)
        .then((res) => {
          this.fileDownload(res, "pdf");
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    findSummary(item) {
      this.getPasUserList({ id: item.id }).then((res) => {
        this.tokenSummaryData = res.data.records[0];
        this.summary = true;
      });
    },
    fetchPas() {
      this.loader = true;
      this.getPasUserList({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.Pas = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    clearInput(val) {
      if (val == "this.from_date") {
        this.from_date = null;
      } else if (val == "this.to_date") {
        this.to_date = null;
      }
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      this.token_number = null;
      this.purpose = null;
      this.storer_id = null;
      this.active = null;
      this.latest_event_status = null;
      this.to_date = null;
      this.from_date = null;
      this.wms_warehouse_code = null;
      this.vehicle_type = null;
      this.dock_numbers = [];
      this.dock_number = [];

      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        token_number: this.token_number,
        purpose: this.purpose,
        storer_id: this.storer_id,
        active: this.active,
        latest_event_status: this.latest_event_status,
        to_date: this.to_date,
        from_date: this.from_date,
        wms_warehouse_code: this.wms_warehouse_code,
        vehicle_type: this.vehicle_type,
        dock_number: Array.isArray(this.dock_number)
          ? this.dock_number.join(",")
          : this.dock_number,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    async searchAll() {
      this.options.page = 1;
      await this.allFilters();
      this.fetchPas();
      //   this.getPas({
      //     ...this.filtersArr,
      //     pagination: 0,
      //   })
      //     .then((res) => {
      //       this.loader = false;
      //       this.Pas = res.data;
      //     })
      //     .catch(() => {
      //       this.loader = false;
      //     });
    },
    checkFunction(value) {
      this.dock_numbers = [];
      this.dock_number = [];
      const targetObject = this.warehouseesList.find((obj) => obj[value]);
      if (targetObject) {
        this.dock_numbers = targetObject[value].dock_number;
      } else {
        this.dock_numbers = [];
      }
    },
  },
};
</script>
<style lang="scss">
.v-btn--icon.v-size--default {
  height: 25px;
  width: 25px;
}
.p-0 {
  padding: 0px !important;
}

.layout.wrap.pt-3 {
  padding-left: 38px !important;
}
.card-title {
  padding-left: 22px;
}
.theme--light.v-data-table.custom-class
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  padding-left: 12px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.v-data-table.custom-class > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 48px;
  padding-left: 12px;
}
.tl-item {
  margin: 0;
  padding: 0;
}
.v-timeline
  cutom-timeline
  v-timeline--align-top
  v-timeline--dense
  theme--light::before {
  left: 13px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-timeline .wrap {
  padding-left: 5px;
  padding-left: 0px;
}
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 9px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}

.mt {
  margin-top: 16px;
}
ul.tl li .item-detail {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
ul.tl li .timestamp {
  color: #8d8d8d;
  position: absolute;
  margin-left: -164px;
  text-align: right;
  font-size: 12px;
}
.history-tl-container-order {
  height: 55px;
  font-family: "Roboto", sans-serif;
  width: 60%;
  margin-left: 31%;
  display: block;
  position: relative;
  top: -3px;
}

.history-tl-container-order ul.tl {
  padding: 0;
  display: inline-block;
}
.history-tl-container-order ul.tl li {
  list-style: none;
  margin-left: 0;
  /*background: rgba(255,255,0,0.1);*/
  // border-left: 1px solid black;
  padding: 0 0 20px 20px;
  // position: relative;
  // height: 45px;
  line-height: 1px;
}

/* Container for the vertical line and icon */
.vertical-line {
  position: relative;
  display: inline-block;
  left: -30px;
  top: 12px;
}

/* Vertical line */
.vertical-line::before {
  content: "";
  position: absolute;
  top: 16px;
  left: 43%;
  transform: translateX(-50%);
  height: 43px;
  width: 1px;
  background-color: black;
}

/* Icon */
.icon {
  position: relative; /* Ensure the icon is in front of the line */
  font-size: 24px; /* Adjust icon size as needed */
  z-index: 1; /* Place the icon above the line */
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 14px;
  text-align: center;
}
.badge-force {
  display: inline-block;
  padding: 4px 10px;
  background-color: orange;
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 12px;
  text-align: center;
}
</style>
